module.exports = __webpack_public_path__ + "9af4274bbbd896e6dcb9c8ab2a5b12d7.pdf";